import Footer from "./components/Footer";
import HomeSlider from "./components/HomeSlider";
import TablesGifSection from "./components/TablesGifSection";
import Sidebar from "./components/Sidebar";
import TabSection from "./components/TabSection";
import TopBar from "./components/TopBar";
import MobileNavbar from "./components/MobileNavbar";
import MobileBottombar from "./components/MobileBottombar";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from "./components/Layout";
import Home from "./Home";
import Slot from "./Slot";
import Casino from "./Casino";
import Info from "./Info";
import SingleSlot from "./SingleSlot";
import Cash1 from "./Cash1";
import Cash2 from "./Cash2";
import Betting from "./Betting";
import Notice from "./Notice";
import Event from "./Event";
import Customer from "./Customer";
import Coupon from "./Coupon";
import Memo from "./Memo";
import RecommendList from "./RecommendList";
import Result from "./Result";
import SingleNotice from "./components/SingleNotice";
import WriteCustomerCenter from "./WriteCustomerCenter";
import SingleCustomer from "./components/SingleCoustomer";
import SingleEvent from "./components/SingleEvent";
import MiniGames from "./MiniGames";
import { LoginProvider } from "./context";


function App() {
  return (
    <>
      <Router>
        <LoginProvider>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="slot" element={<Slot />} />
              <Route path="casino" element={<Casino />} />
              <Route path="mini-games" element={<MiniGames />} />
              <Route path="single-slot" element={<SingleSlot />} />
              <Route path="cash_1" element={<Cash1 />} />
              <Route path="cash_2" element={<Cash2 />} />
              <Route path="betting" element={<Betting />} />
              <Route path="notice" element={<Notice />} />
              <Route path="notice/single-notice/:id" element={<SingleNotice />} />
              <Route path="event" element={<Event />} />
              <Route path="event/single-event/:id" element={<SingleEvent />} />
              <Route path="customer" element={<Customer />} />
              <Route path="customer/single-customer/:id" element={<SingleCustomer />} />
              <Route path="customer/write" element={<WriteCustomerCenter />} />
              <Route path="coupon" element={<Coupon />} />
              <Route path="message" element={<Memo />} />
              <Route path="recommend_list" element={<RecommendList />} />
              <Route path="result" element={<Result />} />
            </Route>
            <Route path="info" element={<Info />} />
          </Routes>
        </LoginProvider>
      </Router>

    </>
  );
}

export default App;
